import { render } from "./DialogContainer.vue?vue&type=template&id=deb610b2&scoped=true"
import script from "./DialogContainer.vue?vue&type=script&lang=js"
export * from "./DialogContainer.vue?vue&type=script&lang=js"

import "./DialogContainer.vue?vue&type=style&index=0&id=deb610b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb610b2"]])

export default __exports__